<template>
  <el-card shadow="never">
    <div slot="header" class="cart-header-wrapper">
      <span class="title">Customer Information</span>
      <div class="action">
        <template>
          <customize-button style="margin-right: 20px" @click="$router.go(-1)">
            Cancel
          </customize-button>
          <customize-button type="primary" @click="handleBaseInfoSave">
            Save
          </customize-button>
        </template>
      </div>
    </div>
    <customize-form ref="form" :schema="infoSchema" :model="model" />
  </el-card>
</template>

<script>
import {
  addOrUpdateBaseInfo,
  getCurrencyList,
} from '../detail/info/basic-profile/api'
import { getSelectList } from '@/api'

const selectList = [
  'Country',
  'Region',
  'CCA',
  'Business',
  'Geo',
  // 'SalesCountry',
  'BU',
]

export default {
  data() {
    return {
      infoSchema: [
        {
          label: 'Customer #',
          type: 'Despace',
          key: 'code',
        },
        {
          label: 'Customer Name',
          type: 'input',
          key: 'name',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'Currency',
          type: 'select',
          placeholder: 'All',
          key: 'currency',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Business Type',
          type: 'select',
          placeholder: 'All',
          key: 'business',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'GEO',
          type: 'select',
          placeholder: 'All',
          key: 'geo',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          change: this.handleGeoSelectChange,
        },
        {
          label: 'Region',
          type: 'select',
          placeholder: 'All',
          key: 'region',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          change: this.handleRegionSelectChange,
          value: '',
        },
        {
          label: 'Payment Term(Day)',
          type: 'input',
          key: 'paymentTermReq',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'Registration Country',
          type: 'select',
          placeholder: 'All',
          key: 'country',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'CCA',
          type: 'select',
          placeholder: 'All',
          key: 'cca',
          selectList: [],
        },
        {
          label: 'Sub-Region',
          type: 'input',
          key: 'subRegion',
          selectList: [],
        },
        {
          label: 'State',
          type: 'input',
          key: 'state',
        },
        {
          label: 'ZIP Code',
          type: 'input',
          key: 'zipCode',
        },
        {
          label: 'Source',
          type: 'select',
          placeholder: 'All',
          value: this.$store.state.source,
          disabled: true,
          key: 'source',
          selectList: [
            { id: 1, name: 'Lenovo' },
            { id: 2, name: 'CSS' },
          ],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'City',
          type: 'input',
          key: 'city',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'Duns #',
          type: 'input',
          key: 'dunsNo',
        },
        {
          label: 'Address',
          type: 'input',
          key: 'address',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'In Business Since:(YYYY-MM-DD)',
          type: 'date',
          key: 'registerDate',
        },
        {
          label: 'Year With Lenovo Since:(YYYY-MM-DD)',
          type: 'date',
          key: 'signDate',
        },
        {
          label: 'Sold to #',
          type: 'input',
          key: 'soldPartyNo',
        },
        {
          label: 'National Registration # or VAT #',
          type: 'input',
          key: 'registeredNo',
        },
        {
          label: 'LINK ID',
          type: 'input',
          key: 'linkId',
        },
        {
          label: 'Phone',
          type: 'input',
          key: 'mobile',
        },
        {
          label: 'Risk Category in SAP',
          type: 'select',
          key: 'sapRiskType',
          placeholder: 'All',
          selectList: [
            {
              id: '001',
              name: '001',
            },
            {
              id: '002',
              name: '002',
            },
            {
              id: '003',
              name: '003',
            },
            {
              id: '004',
              name: '004',
            },
            {
              id: '005',
              name: '005',
            },
            {
              id: '006',
              name: '006',
            },
            {
              id: '999',
              name: '999',
            },
          ],
        },
        // {
        //   label: 'Hierarchy Level',
        //   type: 'select',
        //   key: 'hierarchyLevel',
        //   placeholder: 'All',
        //   selectList: [
        //     {
        //       id: '1',
        //       name: 'Parent',
        //     },
        //     {
        //       id: '2',
        //       name: 'Subsidiary',
        //     },
        //   ],
        // },
        {
          label: 'Sales Country',
          type: 'select',
          key: 'salesCountry',
          placeholder: 'All',
          selectList: [],
        },
        {
          label: 'BU',
          type: 'select',
          key: 'bu',
          placeholder: 'All',
          selectList: [],
        },
      ],
      model: {},
    }
  },
  created() {
    this.getAllSelect()
    this._getCurrencyList()
  },
  methods: {
    async handleGeoSelectChange(value, formData) {
      try {
        if (!value) {
          for (let i = 0; i < this.infoSchema.length; i++) {
            const item = this.infoSchema[i]
            if (item.label === 'Region') {
              item['selectList'] = []
            }
          }
          this.model = { ...formData }
          this.model.region = ''
          return
        }
        const res = await this._getSelectList({
          typeMark: 'Region',
          pid: value,
        })
        for (let i = 0; i < this.infoSchema.length; i++) {
          const item = this.infoSchema[i]
          if (item.label === 'Region') {
            item['selectList'] = res
          }
        }
        this.model = { ...formData }
        this.model.region = ''
      } catch (err) {
        console.error(err)
      }
    },
    async handleRegionSelectChange(value, formData) {
      try {
        // 当region == OEM时，不联动，显示所有国家  OEM的value为1434758713631649794
        const regionOEM = [
          '1396671261928956221',
          '1485507981976072193',
          '1485507838971277313',
          '1485504000834990081',
          '1485508292971130882',
          '1485508065744711682',
        ]
        if (regionOEM.includes(value)) {
          const res1 = await this._getSelectList({
            typeMark: 'Country',
          })
          for (let i = 0; i < this.infoSchema.length; i++) {
            const item = this.infoSchema[i]
            if (item.label === 'Sales Country') {
              item['selectList'] = res1
            }
          }
        } else {
          if (!value) {
            for (let i = 0; i < this.infoSchema.length; i++) {
              const item = this.infoSchema[i]
              if (item.label === 'Sales Country') {
                item['selectList'] = []
              }
            }
            this.model = { ...formData }
            this.model.salesCountry = ''
            return
          }
          const res = await this._getSelectList({
            typeMark: 'Country',
            pid: value,
          })
          for (let i = 0; i < this.infoSchema.length; i++) {
            const item = this.infoSchema[i]
            if (item.label === 'Sales Country') {
              item['selectList'] = res
            }
          }
        }
        this.model = { ...formData }
        this.model.salesCountry = ''
      } catch (err) {
        console.error(err)
      }
    },
    async _getCurrencyList() {
      try {
        const data = await getCurrencyList()
        for (let i = 0; i < this.infoSchema.length; i++) {
          const item = this.infoSchema[i]
          if (item.label === 'Currency') {
            item['selectList'] = data.map(item => ({
              name: item.currencyName,
              id: item.currency,
            }))
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [
              countryList,
              regionList,
              ccaList,
              businessList,
              geoList,
              BuList,
            ] = res
            console.log(regionList)
            // 基本信息
            for (let i = 0; i < this.infoSchema.length; i++) {
              const item = this.infoSchema[i]
              if (item.label === 'Region') {
                item['selectList'] = []
              } else if (item.label === 'Registration Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business Type') {
                item['selectList'] = businessList
              } else if (item.label === 'GEO') {
                item['selectList'] = geoList
              } else if (item.key === 'salesCountry') {
                item['selectList'] = []
              } else if (item.key === 'bu') {
                item['selectList'] = BuList
              }
            }

            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.error(`search 列表查询错误:${err}`)
        })
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.error(err)
      }
    },
    // 点击添加按钮
    async handleBaseInfoSave() {
      try {
        const { form } = this.$refs
        const valid = await form.validateFields()
        if (valid) {
          const params = form.getFormData()
          params.code = params.code.replace(/[ ]/g, '')
          const data = await addOrUpdateBaseInfo(params)
          if (data.name === 2) {
            this.$message.warning('The customer name already exists')
          }
          this.timer = setTimeout(() => {
            this.$message.success('success')
            this.$router.go(-1)
          }, 1000)
        }
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>
